import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackErrorComponent, SnackSuccessComponent } from '@pcscol-portail/composants-pegase';
import { NotificationService } from './notification.service';
import { SnackCustomOdfComponent } from './snack-custom-odf/snack-custom-odf.component';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        MatSnackBarModule,
        MatProgressBarModule,
        SnackErrorComponent,
        SnackSuccessComponent,
        SnackCustomOdfComponent
    ],
    exports: [SnackCustomOdfComponent],
    providers: [NotificationService]
})
export class NotificationModule {}
